<template>
    <div class="">
<!--        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    width="160"
                    label="封面">
                    <template slot-scope="scope">
                        <el-image
                            style="width: 150px; height: 90px"
                            :src="scope.row.goods.coverImg"
                            :lazy="true"
                            :preview-src-list="[scope.row.coverImg]"
                            fit="fill"></el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="goods.name"
                    label="名称" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="express"
                    label="快递公司" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="code"
                    label="订单号" >
                </el-table-column>
                <el-table-column
                    prop="score"
                    min-width="120"
                    label="消耗创新币" >
                </el-table-column>
                <el-table-column
                    prop="user.name"
                    min-width="120"
                    label="员工" >
                </el-table-column>
                <el-table-column
                    prop="applyDate"
                    min-width="120"
                    label="申请时间" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="address"
                    label="收件地址" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="receiveDate"
                    label="领取时间" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="stateName"
                    label="发货处理" >
                </el-table-column>
                <el-table-column
                    min-width="180"
                    prop="feedback"
                    label="反馈" >
                </el-table-column>
                <el-table-column
                    label="操作"
                    min-width="150"
                    fixed="right"
                >
                    <template slot-scope="scope" v-if="scope.row.state == 1">
                        <el-link type="primary" @click="edit(scope.row)"
                                 :underline="false" ><i class="iconfont icon-bianji"></i><b>发货地址</b></el-link>
                        <br>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
       -->
        <div v-for="item in tableData" :key="item.id" class="item_block">
            <div class="fx fx-c_center info_row">
                <div class="coverimg">
                    <el-image
                        style="width: 150px"
                        :src="item.goods.coverImg"
                        :lazy="true"
                        :preview-src-list="[item.goods.coverImg]"
                        fit="fill"></el-image>
                </div>

                <div style="width: 380px;" >
                    <div class="lesson_name">{{item.goods.name}}</div>
                    <div class="fx fx-m_between fx-c_center lesson_resource" style="margin-top: 12px">
                        <span><img src="http://assets.program.leadersir.cn/activity/1671440338131_388/img_v2.jpg" alt="" style="width: 46px;margin-left: -9px;">
                            <span style="position: relative;top: -16px;font-size: 16px;font-weight: bold;">{{item.score}}</span>
                        </span>
                    </div>
                </div>

                <div class="fx-g1">
                    <div class="aaaaa">兑换时间：{{item.applyDate}}</div>
                    <div class="aaaaa">发货时间：{{item.checkDate}}</div>
                    <div class="aaaaa">发货快递：{{item.express}}</div>
                    <div class="aaaaa">快递单号：{{item.code}}</div>
                </div>
                <div class="fx-g1" style="font-size: 20px;font-weight: bold;">
                    状态：{{item.stateName}}
                </div>
                <div style="width: 160px" class="fx fx-m_between fx-c_center">
                    <el-button type="warning" round @click="edit(item)" v-if="item.state == 1">修改地址</el-button>
                    <el-button type="info" round disabled v-if="item.state == 2">已发货</el-button>
                    <el-button type="info" round disabled v-if="item.state == 3">审核未通过</el-button>
                    <el-button type="info" round disabled v-if="item.state == 4">已领取</el-button>
                    <el-button type="warning" round @click="edit(item)" v-if="item.state == 6">申请发货</el-button>
                </div>

            </div>
        </div>
        <template>
            <el-dialog title="填写收货信息" :visible.sync="dialogTableVisible" center width="35%" class="task_dialog">
                <el-form ref="form" :model="form" label-width="150px" class="edit_form">
                    <el-form-item label="收货人">
                        <el-input v-model="form.userName"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码">
                        <el-input v-model="form.phone"></el-input>
                    </el-form-item>
                    <el-form-item label="详细地址">
                        <el-input v-model="form.address"></el-input>
                    </el-form-item>
                </el-form>
                <span class="fx fx-center">
                    <el-button type="info"  @click="close()" round>取消发货</el-button>
                    <el-button type="warning" @click="sub()" round>确认发货</el-button>
                </span>
            </el-dialog>
        </template>
        <GoodsChangeEditDrawer v-if="showEdit" @submit="loadData"
                               @close="showEdit=false" :item="editItem"></GoodsChangeEditDrawer>
    </div>
</template>

<style scoped>
    .aaaaa{
        margin: 5px 0px;
    }
    .el-image__inner{
        height:100%;
    }
    .tip {
        padding:0 6px 0 12px;
    }
    .item_block {
        background: white;
        padding: 15px 40px;
        border-radius: 6px;
        margin-bottom: 10px;
    }
    .info_row>*:not(:first-child) {
        margin-left: 50px;
    }

    .coverimg {
        width: 160px;
    }
    .lesson_name {
        font-size: 16px;
        font-weight: bold;
        color: var(--dark);
    }
    .lesson_resource i.iconfont, .task_info i.iconfont {
        vertical-align: text-bottom;
    }

    .task_item {
        height: 50px;
        /*border-bottom: 1px solid var(--border);*/
    }
</style>

<script>
import GoodsChangeEditDrawer from './ChangeEditDrawer';
import {mapState, mapMutations} from "vuex";

export default {
    components: {
        GoodsChangeEditDrawer
    },
    props: [
        "attr"
    ],
    data() {
        return {
            editItem: {},
            showEdit: false,
            form: {
            },
            pager: {
                pageSize: 12,
                dataTotal: 0,
                currentPage: 1
            },
            tableData: [],
            dialogTableVisible: false,
        }

    },

    watch: {
        /*"form": {
            handler: function (newValue) {
                this.pager.currentPage = 1;
                this.loadData();
            },
            deep: true

        }*/
    },

    methods: {
        edit(item) {
            //this.editItem = {...item};
            //this.showEdit = true;
            this.form = item;
            this.dialogTableVisible = true;
        },
        loadData() {
            this.$ajaxPost("/exchangeRecord/list", {
                //form: this.form,
                pager: {...this.pager, dataTotal: 0}
            }, (data) => {
                //分页不能带offset，否则会影响后台计算最新offset
                let {offset, ...pager} = data.pager;
                this.pager = pager;
                this.tableData = data.result;
                this.showEdit = false;
            })
        },
        pageChange(page) {
            this.pager.currentPage = page;
            this.loadData();
        },
        close(){
          this.dialogTableVisible = false;
        },
        sub(){
            this.$ajaxPost("/exchangeRecord/save", {
                exchangeRecord: this.form
            }, (data) => {
                this.dialogTableVisible = false;
                this.loadData();
            })
        },
    },
    created() {
        this.loadData();
    }

}
</script>
